import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "holder" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "playlist-descr mx-2 mb-2 d-lg-none" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "d-flex align-items-start wrapper" }
const _hoisted_6 = { class: "col-12 col-lg-3 col-playlist" }
const _hoisted_7 = { class: "col-12 col-lg-8 presented-story" }

import ListOfStories from './playlist-tabs/PlaylistPageListOfStories.vue';
import PresentedStories from './playlist-tabs/PlaylistPagePresentedStoriesPanes.vue';
import { usePlaylistStore } from '@/stores/playlistStore';
import { onMounted, useAttrs, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaylistPage',
  setup(__props) {

const attrs = useAttrs();

const playlistStore = usePlaylistStore();

const stories = computed(() => playlistStore.stories);
const title = computed(() => playlistStore.title);
const description = computed(() => playlistStore.description);

const playlistPageUrl = computed(() => `/${attrs.playlistsRoute as string}`)

const returnLabel = computed(() => playlistStore.getLocalization("PlaylistPage.Return"))

// data-return-mode="history" (Media Playlist page): go back when the previous page is on this site, else follow
// the href. Without it the link always goes to the playlists overview, as before.
function onReturn(event: MouseEvent) {
    if (attrs.returnMode !== 'history' || !cameFromThisSite()) {
        return
    }

    event.preventDefault()
    history.back()
}

function cameFromThisSite() {
    if (!document.referrer || history.length < 2) {
        return false
    }

    try {
        return new URL(document.referrer).origin === location.origin
    } catch {
        return false
    }
}

onMounted(async () => {
    await playlistStore.fetchPlaylist(attrs.listid as string, attrs.api as string | undefined)
    await playlistStore.initProgressArray()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _unref(playlistPageUrl),
      class: "link-return mb-2 mx-2",
      onClick: onReturn
    }, _toDisplayString(_unref(returnLabel)), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_unref(title)), 1),
      _createElementVNode("p", { innerHTML: _unref(description) }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ListOfStories, {
          stories: _unref(stories),
          title: _unref(title),
          description: _unref(description)
        }, null, 8, ["stories", "title", "description"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(PresentedStories, { stories: _unref(stories) }, null, 8, ["stories"])
      ])
    ])
  ]))
}
}

})